import { useTheme } from '../lib/theme-provider';

interface ThemedCardProps {
  children: React.ReactNode;
  className?: string;
  hoverable?: boolean;
  onClick?: () => void;
}

export function ThemedCard({ 
  children, 
  className = '', 
  hoverable = false,
  onClick,
}: ThemedCardProps) {
  const { theme } = useTheme();
  
  const baseStyles = 'transition-theme';
  const hoverStyles = hoverable ? 'hover-scale-theme cursor-pointer' : '';
  
  return (
    <div
      className={`${baseStyles} ${hoverStyles} ${className}`}
      onClick={onClick}
      style={{
        backgroundColor: theme.colors['bg-card'],
        borderRadius: theme.effects['radius-card'],
        boxShadow: theme.effects['shadow-card'],
        border: `1px solid ${theme.colors['border-primary']}`,
      }}
    >
      {children}
    </div>
  );
}
